/**
 * Transforms order data into a standardized product format
 * @param {Array} orders - Order data from API
 * @param {Array} listings - Listing data
 * @param {Object} catalogMetadata - Catalog metadata with menuId, dietId, mealSizeId
 * @returns {Array} Transformed products
 */
export function transformOrdersToProducts(orders, listings, catalogMetadata) {
  if (!orders || !listings || !catalogMetadata) return [];

  const { menuId, dietId, mealSizeId } = catalogMetadata;

  return orders
    .flatMap((order) => {
      const listing = listings.find((l) => l.id === order.productSetId);
      if (!listing || listing.productIds.length === 0) {
        return null;
      }

      const entryMenuId = listing.assignments.find((a) => a.subCatalogId === menuId)?.nodeId;
      const entryDietId = listing.assignments.find((a) => a.subCatalogId === dietId)?.nodeId;
      const entryMealSizeId = listing.assignments.find((a) => a.subCatalogId === mealSizeId)?.nodeId;

      return listing.productIds.map((pid) => ({
        payerId: order.payerId,
        productId: pid,
        entryMenuId,
        entryDietId,
        entryMealSizeId,
        count: order.count,
        delivered: order.delivered > 0 ? order.count : 0,
        payerGroups: order.payerGroups || [],
      }));
    })
    .filter((x) => x);
}

/**
 * Handles single menu case by using provided menuNodes and diets
 * @param {Array} products - Transformed products
 * @param {Array} menuNodes - Menu nodes from catalog
 * @param {Array} diets - Diet nodes from catalog
 * @returns {Array} Products with resolved IDs for single menu/diet cases
 */
export function resolveProductIds(products, menuNodes, diets) {
  const singleMenuId = menuNodes.length === 1 ? menuNodes[0].nodeId : null;
  const singleDietId = diets.length === 1 ? diets[0].nodeId : null;

  return products.map((product) => ({
    ...product,
    entryMenuId: singleMenuId || product.entryMenuId,
    entryDietId: singleDietId || product.entryDietId,
  }));
}
